import React from 'react';
import { Field, inputClass } from './BackgroundFields';
import FontFamilySelectField from './FontFamilySelectField';
import { clampMenuFontSize } from '../../../utils/editorTypography';

export default function MenuTypographyFields({ props, setProp, setProps, siteTypography }) {
  const tabSize = props.menuTabFontSize ?? props.menuFontSize ?? 14;

  return (
    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">Typographie des onglets</p>
      <Field label="Taille des onglets (px)">
        <input
          type="number"
          min={8}
          max={96}
          className={inputClass}
          value={tabSize}
          onChange={(e) => {
            const px = clampMenuFontSize(e.target.value);
            if (setProps) {
              setProps({ menuTabFontSize: px, menuFontSize: px });
            } else {
              setProp('menuTabFontSize', px);
            }
          }}
        />
      </Field>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={props.inheritSiteMenuFont !== false}
          onChange={(e) => setProp('inheritSiteMenuFont', e.target.checked)}
        />
        <span className="text-sm">
          <span className="font-medium text-foreground block">Hériter de la police du site</span>
          <span className="text-xs text-muted-foreground">
            Sinon, choisissez une police pour les libellés du menu.
          </span>
        </span>
      </label>
      {props.inheritSiteMenuFont === false ? (
        <FontFamilySelectField
          value={props.menuFontFamily || 'system'}
          onChange={(v) => setProp('menuFontFamily', v)}
          siteTypography={siteTypography}
        />
      ) : null}
    </div>
  );
}
